import {
	ComboBoxInputNavigationBorderVars,
	ComboBoxInputNavigationCSSVars,
	CompInfo,
	DropDownMenuBrightnessCSSVars,
	DropDownMenuCSSVars,
	DropDownMenuDefinition,
	DropDownMenuUIType,
} from '@wix/thunderbolt-components-native'
import { getComboBoxInputNavigationCSSVars } from '../../core/mappers/MenuItems/MenuItems.utils'
import { withCompInfo } from '@wix/editor-elements-integrations'
import { StyleProperties, colorApi } from '@wix/thunderbolt-becky-root'

const getMenuBorderX = (skin: DropDownMenuDefinition['skin'], styleProperties: StyleProperties): number | 0 => {
	const menuTotalBordersX = styleProperties.menuTotalBordersX
	const brwParam = styleProperties.brw
	const doubleBorder = (!brwParam ? 0 : parseInt(brwParam, 10)) * 2
	return skin === 'SolidColorMenuButtonSkin' ? doubleBorder : menuTotalBordersX ? parseInt(menuTotalBordersX, 10) : 0
}

const getMenuBorderY = (
	skin: DropDownMenuDefinition['skin'],
	styleProperties: StyleProperties,
	fallbackToZero: boolean
): number | 0 => {
	const menuTotalBordersY = styleProperties.menuTotalBordersY
	const brwParam = styleProperties.brw
	const doubleBorder = (!brwParam ? 0 : parseInt(brwParam, 10)) * 2
	if (['LinesMenuButtonSkin', 'LinesMenuButtonBorderRadiusFixSkin', 'SolidColorMenuButtonSkin'].includes(skin)) {
		return doubleBorder
	} else if (fallbackToZero) {
		return 0
	} else if (menuTotalBordersY) {
		return parseInt(menuTotalBordersY, 10)
	} else {
		return 0
	}
}

const defaultCss = (compInfo: Pick<CompInfo, 'styleProperties' | 'skin' | 'siteColors'>): DropDownMenuCSSVars => {
	const { skin, styleProperties, siteColors } = compInfo
	const brightnessParams =
		skin === 'VerticalRibbonsMenuButtonSkin'
			? {
					...colorApi.getBrightnessCSSVars<Pick<DropDownMenuBrightnessCSSVars, '--bgh-mutated-brightness'>>({
						paramName: 'elmOver',
						mutatedParamName: 'bgh',
						alpha: 0.7,
						styleProperties,
						siteColors,
					}),
					...colorApi.getBrightnessCSSVars<Pick<DropDownMenuBrightnessCSSVars, '--bgs-mutated-brightness'>>({
						paramName: 'elmSelected',
						mutatedParamName: 'bgs',
						alpha: 0.7,
						styleProperties,
						siteColors,
					}),
			  }
			: {}

	return {
		...brightnessParams,
		'--menuTotalBordersY': `${getMenuBorderY(skin, styleProperties, false)}px`,
		'--menuTotalBordersX': `${getMenuBorderX(skin, styleProperties)}px`,
	}
}

const calcArrowBorderWidth = (alignText: 'left' | 'center' | 'right') => {
	const isRightAligned = alignText === 'right'
	const arrowLeftBorderWidth = isRightAligned ? '0' : '1px'
	const arrowRightBorderWidth = isRightAligned ? '1px' : '0'
	return `0 ${arrowRightBorderWidth} 0 ${arrowLeftBorderWidth}`
}

const comboBoxInputCss = (
	compInfo: Pick<
		CompInfo,
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		'compLayout' | 'styleProperties' | 'siteFonts' | 'isMobileView' | 'compProps' | 'isOneDocMigrated'
	>
): ComboBoxInputNavigationCSSVars => {
	const alignText = compInfo.compProps.alignText

	const borders: ComboBoxInputNavigationBorderVars = {
		'--arrowBorderWidth': calcArrowBorderWidth(alignText),
	}

	// @ts-ignore
	return getComboBoxInputNavigationCSSVars(compInfo, alignText, borders, compInfo.isOneDocMigrated)
}

// @ts-ignore - remove once withCompInfo supports return of string for uiType
export const uiType = withCompInfo<DropDownMenuUIType, DropDownMenuDefinition>()(
	['skin', 'isMobileView'],
	({ skin, isMobileView }) => {
		if (isMobileView) {
			return 'ComboBoxInputNavigation'
		}
		return skin
	}
)

export const css = withCompInfo<DropDownMenuCSSVars, DropDownMenuDefinition>()(
	[
		'uiType',
		'compProps',
		'compLayout',
		'styleProperties',
		'siteFonts',
		'isMobileView',
		'skin',
		'siteColors',
		// @ts-ignore - remove once isOneDocMigrated is added to CompInfo
		'isOneDocMigrated',
	],
	(compInfo) => {
		// @ts-ignore - remove once siteFonts is added to CompInfo
		return compInfo.uiType === 'ComboBoxInputNavigation' ? comboBoxInputCss(compInfo) : defaultCss(compInfo)
	}
)
